import { createContext } from 'react';

export const defaultState = {
  loading: true,
  broadband: {},
  selectedBBOffer: null,
  prequalSuccess: null,
  loginState: false,
  loginUserEmail: null,
};

export const reducer = (state, action) => {
  switch (action.type) {
    case 'loading':
      return { ...state, loading: true };
    case 'SET_BROADBAND':
      return { ...state, broadband: action.payload };
    case 'LOGIN':
      return { ...state, loginState: true, loginUserEmail: action.payload.email };
    default:
      break;
  }
};

const BroadbandContext = createContext();

export default BroadbandContext;
